import api from "../../../api";
export default {
  getcmdetails(params) {
    return api.get("accounting/getCMDetails", { params });
  },
  creditmemoprint(id) {
    return api.post(`accounting/creditmemo/print/${id}`);
  },
  approvecreditmemo(id, params) {
    return api.post(`accounting/creditmemo/approve/${id}`, params);
  },
  rejectcreditmemo(params) {
    return api.get(`accounting/rejectCreditMemo`, { params });
  },
  getallcm(params) {
    return api.post(`accounting/creditmemo/getAll`, params);
  },
  showcm(id) {
    return api.get(`accounting/creditmemo/${id}`);
  },
  postcm(params, config) {
    return api.post(`accounting/creditmemo`, params, config);
  },
  updatecm(params, config) {
    return api.post(`accounting/creditmemo/updateCreditMemo`, params, config);
  },
  deletecm(id) {
    return api.delete(`accounting/creditmemo/${id}`);
  },
  cancelcm(id) {
    return api.post(`accounting/creditmemo/cancel/${id}`);
  },
  getcustomersoas(id) {
    return api.get(`accounting/creditmemo/getCustomerSoas/${id}`);
  },
  getcustomerpaymentdetailfiles(id) {
    return api.get(`accounting/getCustomerPaymentDetailFiles/${id}`);
  },
  getcreditmemofiles(id) {
    return api.get(`accounting/creditmemo/getCreditMemoFiles/${id}`);
  },
  getdebitmemofiles(id) {
    return api.get(`accounting/debitmemo/getDebitMemoFiles/${id}`);
  },
  deletecustomerpaymentdetailfile(params) {
    return api.post(`accounting/deleteCustomerPaymentDetailFile`, params);
  },
  deletecreditmemofile(params) {
    return api.post(`accounting/creditmemo/deleteCreditMemoFile`, params);
  },
  deletedebitmemofile(params) {
    return api.post(`accounting/debitmemo/deleteDebitMemoFile`, params);
  },
  printcreditmemo(id) {
    return api.post(`accounting/creditmemo/print/${id}`);
  },
  getdmdetails(params) {
    return api.get(`accounting/getDMDetails/`, params);
  },
  printdebitmemo(id) {
    return api.post(`accounting/debitmemo/print/${id}`);
  },
  approvedm(id, params) {
    return api.post(`accounting/debitmemo/approve/${id}`, params);
  },
  rejectdm(params) {
    return api.get(`accounting/rejectDebitMemo`, { params });
  },
  getalldm(params) {
    return api.post(`accounting/debitmemo/getAll`, params);
  },
  showdm(id) {
    return api.get(`accounting/debitmemo/${id}`);
  },
  postdm(params, config) {
    return api.post(`accounting/debitmemo`, params, config);
  },
  updatedm(params, config) {
    return api.post(`accounting/debitmemo/updateDebitMemo`, params, config);
  },
  deletedm(id) {
    return api.delete(`accounting/debitmemo/${id}`);
  },
  canceldm(id) {
    return api.post(`accounting/debitmemo/cancel/${id}`);
  },
  getitemcreditmemo(id, params) {
    return api.get(`reports/getItemCreditMemo/${id}`, { params });
  },
  getitemdebitmemo(id, params) {
    return api.get(`reports/getItemDebitMemo/${id}`, { params });
  },
  getCreditMemoTypes(params) {
    return api.get(`accounting/getCreditMemoTypes`, { params });
  },
  getDebitMemoTypes(params) {
    return api.get(`accounting/getDebitMemoTypes`, { params });
  },
  getCreditMemoTypeStatus(params) {
    return api.get(`accounting/getCreditMemoTypeStatus`, { params });
  },
  postCreditMemoHistory(params) {
    return api.post(`accounting/${params.url}`, params);
  },
  getCreditMemoHistory(params) {
    return api.get(`accounting/${params.url}`, { params });
  },
  getCreditMemoTypesCardTotal(params) {
    return api.get(`accounting/getCreditMemoTypesCardTotal`, { params });
  },
  massImportCreditMemos(params) {
    return api.post(`accounting/creditmemo/massImport`, params);
  },
  getApprovedPrintedFromSystems(params) {
    return api.post(`accounting/creditmemo/getApprovedPrintedFromSystems`, params);
  },
  getApprovedPrintedForExport(params) {
    return api.post(`accounting/creditmemo/getApprovedPrintedForExport`, params);
  },
  skipCreditMemo(params) {
    return api.post(`accounting/creditmemo/skipCreditMemo`, params);
  },
  getCreditMemoItemsFromSystem(params) {
    return api.post(`accounting/creditmemo/getCreditMemoItemsFromSystem`, params);
  },
  getLinkedCustomers() {
    return api.get(`accounting/creditmemo/getLinkedCustomers`);
  },
  massImportDebitMemos(params) {
    return api.post(`accounting/debitmemo/massImport`, params);
  },
  getCreditMemoApprovalSettings() {
    return api.get("accounting/creditMemoApprovalSettings");
  },
  storeCreditMemoApprovalBypass(params) {
    return api.post("accounting/creditMemoApprovalBypasses", params);
  },
  updateCreditMemoApprovalBypass(id, params) {
    return api.put(`accounting/creditMemoApprovalBypasses/${id}`, params);
  },
  destroyCreditMemoApprovalBypass(id) {
    return api.delete(`accounting/creditMemoApprovalBypasses/${id}`);
  },
  storeCreditMemoApprovalApprover(params) {
    return api.post("accounting/creditMemoApprovalApprovers", params);
  },
  updateCreditMemoApprovalApprover(id, params) {
    return api.put(`accounting/creditMemoApprovalApprovers/${id}`, params);
  },
  destroyCreditMemoApprovalApprover(id) {
    return api.delete(`accounting/creditMemoApprovalApprovers/${id}`);
  },
  canApproveCreditMemos() {
    return api.get("accounting/canApproveCreditMemos");
  },
  getDebitMemoApprovalSettings() {
    return api.get("accounting/debitMemoApprovalSettings");
  },
  storeDebitMemoApprovalBypass(params) {
    return api.post("accounting/debitMemoApprovalBypasses", params);
  },
  updateDebitMemoApprovalBypass(id, params) {
    return api.put(`accounting/debitMemoApprovalBypasses/${id}`, params);
  },
  destroyDebitMemoApprovalBypass(id) {
    return api.delete(`accounting/debitMemoApprovalBypasses/${id}`);
  },
  storeDebitMemoApprovalApprover(params) {
    return api.post("accounting/debitMemoApprovalApprovers", params);
  },
  updateDebitMemoApprovalApprover(id, params) {
    return api.put(`accounting/debitMemoApprovalApprovers/${id}`, params);
  },
  destroyDebitMemoApprovalApprover(id) {
    return api.delete(`accounting/debitMemoApprovalApprovers/${id}`);
  },
  canApproveDebitMemos() {
    return api.get("accounting/canApproveDebitMemos");
  },
};
